import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

// Fixed QR target printed on the add-on stickers. Only forwards to /add, so the
// destination can change later without reprinting.
const QrAddSticker = () => {
  const [searchParams] = useSearchParams();
  const params = new URLSearchParams(searchParams);
  if (!params.get('src')) params.set('src', 'sticker');
  // The sticker is German, so land in German unless a language is given.
  if (!params.get('lang')) params.set('lang', 'de');
  return <Navigate replace to={`/add?${params.toString()}`} />;
};

export default QrAddSticker;
